(() => {
 const root = () => window.Shopify?.routes?.root || '/';
 const codesFrom = cart => [...new Set([...(cart.discount_codes || []).filter(c => c.applicable !== false).map(c => c.code), ...(cart.cart_level_discount_applications || []).filter(d => d.type === 'discount_code').map(d => d.title), ...(cart.items || []).flatMap(i => (i.line_level_discount_allocations || []).filter(a => a.discount_application?.type === 'discount_code').map(a => a.discount_application.title))])];
 class LennieCartDiscount extends HTMLElement {
  connectedCallback() { this.querySelector('form').addEventListener('submit', e => this.apply(e)); }
  async apply(event) {
   event.preventDefault(); if (this.busy) return;
   const input = this.querySelector('input'), code = input.value.trim(); if (!code) { input.focus(); return; }
   this.busy = true; const button = this.querySelector('button'); button.disabled = true; button.textContent = 'Applying…';
   const status = this.querySelector('[role="status"]'); status.textContent = '';
   try {
    const currentResponse = await fetch(root() + 'cart.js', {headers: {Accept:'application/json'}});
    if (!currentResponse.ok) throw new Error('Could not check your basket. Please try again.');
    const current = await currentResponse.json();
    const codes = [...new Set([...codesFrom(current), code])];
    const response = await fetch(root() + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:codes.join(','),sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});
    const cart = await response.json(); if (!response.ok) throw new Error(cart.description || 'The code could not be applied. Please try again.');
    const match = (cart.discount_codes || []).find(d => d.code.toLowerCase() === code.toLowerCase());
    let message = match?.applicable === false ? 'This code is not valid for your current basket.' : codesFrom(cart).some(c => c.toLowerCase() === code.toLowerCase()) ? 'Discount applied. Your basket has been updated.' : 'Code sent to checkout. Any eligibility requirements will be confirmed there.';
    const drawer = this.closest('cart-drawer');
    if (cart.sections?.['cart-drawer'] && cart.sections?.['cart-icon-bubble']) {
     drawer.renderContents(cart);
     const next = drawer.querySelector('lennie-cart-discount');
     next.querySelector('[role="status"]').textContent = message;
     next.querySelector('input').value = code;
     next.querySelector('input').focus();
     if (typeof trapFocus === 'function') trapFocus(drawer.querySelector('#CartDrawer'), next.querySelector('input'));
    } else { status.textContent = message + ' Refresh the basket to see the latest total.'; }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source:'lennie-discount',cartData:cart});
   } catch(error) { status.textContent = error.message || 'Please try again, or enter your code at checkout.'; }
   finally { this.busy = false; button.disabled = false; button.textContent = 'Apply'; }
  }
 }
 class LennieCartRecommendations extends HTMLElement {
  connectedCallback() {
   this.addEventListener('submit', event => this.addPick(event));
   const drawer = this.closest('cart-drawer');
   if (!drawer) { this.load(); return; }
   this.observer = new MutationObserver(() => { if (drawer.classList.contains('active')) this.load(); });
   this.observer.observe(drawer, {attributes:true,attributeFilter:['class']});
   if (drawer.classList.contains('active')) this.load();
  }
  disconnectedCallback() { this.observer?.disconnect(); this.abort?.abort(); }
  async addPick(event) {
   const form = event.target.closest('.lennie-pick-form'); if (!form) return;
   event.preventDefault(); const button = form.querySelector('button'); if (button.disabled) return;
   const status = form.closest('.lennie-cart-pick').querySelector('[role=status]');
   button.disabled = true; button.textContent = 'Adding…'; status.textContent = '';
   try {
    const data = new FormData(form); data.append('sections','cart-drawer,cart-icon-bubble'); data.append('sections_url',location.pathname);
    const response = await fetch(root()+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:data});
    const item = await response.json(); if (!response.ok || item.status) throw new Error(item.description || 'This item could not be added. Please check its product page.');
    const drawer = document.querySelector('cart-drawer');
    if (drawer && item.sections?.['cart-drawer']) { drawer.renderContents(item); drawer.querySelector('.drawer__close')?.focus(); }
    else location.assign(root()+'cart');
   } catch(error) { status.textContent = error.message || 'Please try again.'; }
   finally { button.disabled = false; button.textContent = 'Add to cart'; }
  }

  async load() {
   if (this.loaded) return; this.loaded = true; this.abort = new AbortController();
   const excluded = new Set(this.dataset.cartProducts.split(','));
   let result; let count = 0;
   try {
    for (const intent of ['complementary','related']) {
     const url = new URL(root()+'recommendations/products',location.origin);
     url.search = new URLSearchParams({section_id:'lennie-cart-recommendations',product_id:this.dataset.productId,limit:'10',intent});
     const response = await fetch(url, {signal:this.abort.signal}); if (!response.ok) continue;
     const doc = new DOMParser().parseFromString(await response.text(),'text/html');
     const content = doc.querySelector('.lennie-cart-picks'); if (!content) continue;
     content.querySelectorAll('[data-product-id]').forEach(card => { if (excluded.has(card.dataset.productId) || count >= 5) card.remove(); else { excluded.add(card.dataset.productId); count++; } });
     if (!result) result = content; else result.querySelector('.lennie-cart-picks__list').append(...content.querySelectorAll('[data-product-id]'));
     if (count >= 5) break;
    }
    if (count && this.isConnected) this.replaceChildren(result);
   } catch { /* Optional suggestions must never prevent shopping or checkout. */ }
  }
 }
 customElements.define('lennie-cart-discount',LennieCartDiscount);
 customElements.define('lennie-cart-recommendations',LennieCartRecommendations);
})();
